var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemographicInfoFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 9.8625H9.9975C8.6625 9.8625 7.575 8.7825 7.575 7.44V5.8125C7.575 5.505 7.3275 5.25 7.0125 5.25H4.635C2.9025 5.25 1.5 6.375 1.5 8.385V13.365C1.5 15.375 2.9025 16.5 4.635 16.5H9.0525C10.785 16.5 12.1875 15.375 12.1875 13.365V10.425C12.1875 10.11 11.9325 9.8625 11.625 9.8625Z",
    fill: "#7A5AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3653 1.5H11.8878H11.0703H8.94781C7.25281 1.5 5.88031 2.58 5.82031 4.5075C5.86531 4.5075 5.90281 4.5 5.94781 4.5H8.07031H8.88781H10.3653C12.0978 4.5 13.5003 5.625 13.5003 7.635V9.1125V11.145V12.6225C13.5003 12.6675 13.4928 12.705 13.4928 12.7425C15.1653 12.69 16.5003 11.58 16.5003 9.6225V8.145V6.1125V4.635C16.5003 2.625 15.0978 1.5 13.3653 1.5Z",
    fill: "#7A5AF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98547 5.36231C8.75297 5.12981 8.35547 5.28731 8.35547 5.60981V7.57481C8.35547 8.39981 9.05297 9.07481 9.90797 9.07481C10.4405 9.08231 11.183 9.08231 11.8205 9.08231C12.143 9.08231 12.308 8.70731 12.083 8.48231C11.2655 7.66481 9.81047 6.20231 8.98547 5.36231Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemographicInfoFilled);
export default __webpack_public_path__ + "static/media/demographic_info_filled.d9126859d1ef9267be2bf3e9248835eb.svg";
export { ForwardRef as ReactComponent };